import React, { useEffect, useRef, useState } from "react"
import "./CourseList.scss"
import CourseApi from "Api/CourseApi"
import {
  Button,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table,
  Spinner,
  Input,
} from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import { useNavigate } from "react-router-dom"
import DataTableLoader from "SkeletonLoader/DataTableLoader"
import { toast, ToastContainer } from "react-toastify"

const CourseList = () => {
  document.title = "Course"

  const accessToken = localStorage.getItem("accessToken")
  const [courseDetails, setCourseDetails] = useState([])
  const [page, setPage] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [limit, setLimit] = useState(10)
  const navigate = useNavigate("")

  const userData = JSON.parse(localStorage.getItem("userData"))
  const [loading, setLoading] = useState(true)
  const [addCourseLoader, setAddCourseLoader] = useState(false)
  const [FilteredCourseDetails,setFilteredCourseDetails]=useState([]);
  const [filterStatus, setFilterStatus] = useState("all");

  const getAllCourseDetails = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params: {
        limit: limit,
        page: page,
      },
    }

    CourseApi.getAllCourse(config)
      .then(response => {
        if (response.data.status) {
          setLoading(false)
          setCourseDetails(response.data.Course)
          setTotalRecords(response.data.totalRecords)
        }
      })
      .catch(error => {
        console.log("Error Fetching course", error)
      })
  }
  useEffect(() => {
    getAllCourseDetails()
  }, [accessToken, page, limit])

   useEffect(() => {
      if (filterStatus === "all") {
        setFilteredCourseDetails(courseDetails);
      } else {
        const filteredData = courseDetails.filter(
          (course) => course.verifiedStatus === filterStatus
        );
        setFilteredCourseDetails(filteredData);
      }
    }, [filterStatus, courseDetails]);

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "Course", link: "#" },
    { label: "Course List", link: "#" },
  ]

  const totalPages = Math.ceil(totalRecords / limit)

  const uploadbtn = useRef()

  const handleUploadButtonClick = () => {
    uploadbtn.current.click()
  }
  const [excelLoader, setExcelLoader] = useState(false)

  const handleFileChange = event => {
    setExcelLoader(true)

    const file = event.target.files[0]
    if (!file) return
    const formData = new FormData()
    formData.append("file", file)

    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    CourseApi.uploadCourseByExcel(formData, config)
      .then(res => {
        getAllCourseDetails()
        console.log(res.data)
        event.target.value = ""
        setExcelLoader(false)
        toast.success(res.data.message)
      })
      .catch(err => {
        console.log(err)
        event.target.value = ""
        setExcelLoader(false)
        toast.error(err.response.data.message)
      })

    // UniversityApi.uploadUniversityByExcel(formData, config)
    //   .then(res => {
    //     getAllUniversityDetails()
    //     console.log(res.data)
    //     event.target.value = ""
    //   })
    //   .catch(err => {
    //     console.log(err)
    //     event.target.value = ""
    //   })
  }
  const handleCourseClick = () => {
    setAddCourseLoader(true)
    setTimeout(() => {
      setAddCourseLoader(false)
      navigate("/addCourse")
    }, 500)
  }

  return (
    <>
    <ToastContainer/>
      <Row>
        <Col xs="12">
          <div className="university-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb data={breadcrumbItems} pageTitle="Course" />
            <div className="d-flex align-items-center gap-3">
            <Input
                type="select"
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                style={{ width: "150px" }}
              >
                <option value="all">All</option>
                <option value="approve">Approved</option>
                <option value="reject">Rejected</option>
                <option value="pending">Pending</option>
              </Input>
              <input
                type="file"
                ref={uploadbtn}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              <Button
                type="button"
                color="success"
                className="waves-effect"
                onClick={handleUploadButtonClick}
              >
                {excelLoader ? (
                  <Spinner size="sm" />
                ) : (
                  <i className="mdi mdi-microsoft-excel" />
                )}
              </Button>

              <Button
                type="button"
                color="secondary"
                className="waves-effect"
                onClick={handleCourseClick}
              >
                {/* {addCourseLoader ? (
                <Spinner size="sm"/>
               ):(
                " Add Course"
                )} */}
                Add Course
              </Button>
            </div>
          </div>

          <div className="course-data-table table-responsive mt-4 mb-3 ">
            {loading ? (
              <DataTableLoader cols={10} />
            ) : (
              <Table className="table mb-0">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Course Name</th>
                    <th>Duration</th>
                    <th>TuitionFee</th>
                    <th>Eligibility Criteria</th>
                    <th>Total Seats</th>
                    <th>Verified Status</th>
                    <th>Edit</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  {FilteredCourseDetails.map((course, index) => (
                    <tr key={course._id} className="university-table-row">
                      <th scope="row">{(page - 1) * limit + index + 1}</th>
                      <td>{course.courseName}</td>
                      <td>{course.duration}</td>
                      <td>{course.tuitionFee}</td>
                      <td>{course.eligibilityCriteria}</td>
                      <td>{course.totalSeats}</td>

                      <td>
                        <span
                          className={`status ${course.verifiedStatus.toLowerCase()}`}
                        >
                          {course.verifiedStatus === "approve"
                            ? "Approved"
                            : course.verifiedStatus === "reject"
                              ? "Rejected"
                              : "Pending"}
                        </span>
                      </td>

                      {course.verifiedStatus === "pending" ||
                      (["approve", "reject"].includes(course.verifiedStatus) &&
                        userData?.role === "manager") ? (
                        <td>
                          <span
                            className="edit-course"
                            onClick={() => {
                              navigate(`/edit-course/${course?._id}`, {
                                state: course,
                              })
                            }}
                          >
                            <i className="ion ion-md-create" />
                          </span>
                        </td>
                      ) : (
                        <td>
                          <span className="edit-course no-access">
                            <i className="fas fa-ban" />
                          </span>
                        </td>
                      )}

                      <td>
                        <span
                          onClick={() => {
                            navigate(`/view-course/${course?._id}`)
                          }}
                          className="view-course"
                        >
                          <i className="ion ion-md-eye" />
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </div>
          <div className="pagination-container d-flex align-items-center justify-content-end">
            <Pagination>
              <PaginationItem disabled={page <= 1}>
                <PaginationLink previous onClick={() => setPage(page - 1)} />
              </PaginationItem>
              {[...Array(totalPages)].map((_, index) => (
                <PaginationItem key={index} active={index + 1 === page}>
                  <PaginationLink onClick={() => setPage(index + 1)}>
                    {index + 1}
                  </PaginationLink>
                </PaginationItem>
              ))}

              <PaginationItem disabled={page >= totalPages}>
                <PaginationLink next onClick={() => setPage(page + 1)} />
              </PaginationItem>
            </Pagination>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default CourseList
